import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { getFormattedLinkToBrowser } from '~/utils/url';

export interface InsurancePolicyInfoProps {
  policyNumber: string;
  policyUrl: string | null;
}

const InsurancePolicyInfo: React.FC<InsurancePolicyInfoProps> = ({
  policyNumber,
  policyUrl,
}) => {
  return (
    <>
      <View className="flex-row items-center justify-between">
        <Text className="text-gray-400 text-sm">Apólice Seguro</Text>
        <Text className="text-gray-400 text-base flex-1 text-right">
          #{policyNumber}
        </Text>
      </View>

      {!!policyUrl && (
        <Text
          className="text-primary-600 font-medium text-xs mt-2 self-start"
          onPress={() =>
            MarisaAppUtils.openUrl(getFormattedLinkToBrowser(policyUrl, true))
          }
        >
          VISUALIZAR PDF
        </Text>
      )}
    </>
  );
};

export default InsurancePolicyInfo;
